// extracted by mini-css-extract-plugin
export default {"records-grid":"ModuleRecords_records-grid__yO89V"};